import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LatestSection from "@/pages/home/components/LatestSection";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "糖豆视频－精选影视综艺高清视频观看平台",
    "糖豆视频提供丰富多样的影视资源和综艺节目，涵盖最新电影、热门电视剧及精彩综艺，用户可以轻松浏览和观看多类型高清视频内容。",
    "糖豆视频,影视视频,在线视频,影视综艺,电影电视剧,高清视频,网络视频平台",
  );

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100">
      <Navbar />
      <main className="w-full flex-1">
        <HeroCarousel />
        <CategoryEntries />
        <FeaturedSection />
        <LatestSection />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}